<template>
  <div class="search_picker_box">
    <van-cell is-link @click="openSheet" :value="sheetValue" />
    <van-action-sheet v-model="sheetShow">
      <div class="picker_content">
        <van-icon name="cross" class="picker_content_icon" @click="sheetShow = false" />
        <van-field class="picker_search" v-model="searchValue" placeholder="搜索" right-icon="search"
          @input="searchInput" />
        <van-loading v-if="searchLoding" class="picker_options_box" style="text-align: left" />
        <div class="picker_options_box" v-else>
          <p :class="[
            'picker_options',
            chooseValue === item.value ? 'is_active' : '',
          ]" v-for="item in sheetColumns" :key="item.value" @click="selectOption(item)">
            {{ item.text }}
            <van-icon v-show="chooseValue === item.value" class="active_icon" name="success" />
          </p>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
    isServe: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
    },
  },
  data() {
    return {
      sheetShow: false,
      chooseValue: "",
      sheetColumns: [],
      sheetValue: "请选择",
      searchValue: "",
      searchLoding: false,
    };
  },
  watch: {
    value: {
      handler(newV) {
        let obj = newV ? JSON.parse(newV) : {};
        this.chooseValue = obj.value ? obj.value : "";
        this.sheetValue = obj.text ? obj.text : "请选择";
      },
      deep: true,
      immediate: true,
    },
    columns: {
      handler(newV) {
        this.sheetColumns = newV;
        this.searchLoding = false;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openSheet() {
      this.$emit('openSearchPick')
      this.sheetShow = true
    },
    searchInput(value) {
      this.searchLoding = true;
      this.$preventFun.Debounce(() => {
        if (this.isServe) {
          this.$emit("searchChange", value);
        } else {
          this.sheetColumns = this.columns.filter((item) =>
            item.text.includes(value)
          );
          this.searchLoding = false;
        }
      }, 1000)();
    },
    selectOption(query) {
      this.sheetValue = query.text;
      this.$emit("input", JSON.stringify(query));
      this.sheetShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.search_picker_box {
  width: 100%;

  &::v-deep .van-cell__value {
    text-align: right;
  }

  &::v-deep .van-cell {
    padding: 0 !important;
    border: none !important;

    &::after {
      border: none;
    }
  }

  .picker_content {
    position: relative;
    padding: 50px 15px 10px;

    .picker_content_icon {
      position: absolute;
      top: 15px;
      right: 15px;
      font-size: 20px;
    }

    .picker_search {
      margin-bottom: 10px;
      height: 35px;
      border: 1px solid #eee !important;
      border-radius: 5px;
      padding: 0 10px !important;

      &::v-deep .van-field__body {
        height: 100%;

        .van-field__control {
          text-align: left;
          font-size: 14px;
        }
      }
    }

    .picker_options_box {
      height: 300px;
      overflow-y: auto;

      .picker_options {
        position: relative;
        padding-right: 20px;
        text-align: left;
        font-size: 14px;
        line-height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .is_active {
        color: #4a79f1;

        .active_icon {
          position: absolute;
          line-height: 40px;
          right: 0;
          top: 0;
        }
      }
    }
  }
}
</style>